import script from "./ModalMudanca.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalMudanca.vue?vue&type=script&setup=true&lang=js"

import "./ModalMudanca.vue?vue&type=style&index=0&id=4bbbc119&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4bbbc119"]])

export default __exports__